import { render, staticRenderFns } from "./DeliveryTomorrow.vue?vue&type=template&id=3bf40944&"
import script from "./DeliveryTomorrow.vue?vue&type=script&lang=js&"
export * from "./DeliveryTomorrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports